document.addEventListener('DOMContentLoaded', function (e) {
    document.addEventListener('click', function (e) {
        const trigger = e.target.closest('.js-video-play');
        if (!trigger) return;

        const parent = trigger.parentElement;

        // Supprime tous les boutons play dans le parent
        parent.querySelectorAll('.js-video-play').forEach(el => el.remove());

        // Affiche la vidéo
        const videoBlock = parent.querySelector('.js-video');
        if (videoBlock) {
            videoBlock.style.display = 'block';
        }

        const video = parent.querySelector('video');
        const iframe = parent.querySelector('iframe');

        if (video) {
            video.play();
        } else if (iframe) {
            const src = iframe.getAttribute('src') || '';
            iframe.setAttribute('src', src + '&autoplay=1');
            iframe.setAttribute('allow', 'autoplay');
        }
    });
})